<div tiptapNodeViewContent class="celleinnhold-kontainer">
  <!-- det brukerstyrte td-innholdet dyttes ut inni her, omsluttet av en div til,
   altså: <div ... class="celleinnhold-kontainer"><div>INNHOLD</div></div> -->
</div>

<span class="menytrigger_celle" data-ikkePropagerHendelserTilTiptap>
  <button mat-icon-button type="button" [matMenuTriggerFor]="cellemeny" (menuOpened)="velgCelle(rammevalgKomponent)" (menuClosed)="cellemenyLukket()" data-testid="cellemeny-trigger">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #cellemeny="matMenu">
    @if (kanSplitteCelle()) {
      <button mat-menu-item type="button" (click)="splittCelle()">
        <mat-icon svgIcon="sf:split-cell"/>
        <span>{{ 'Splitt celle'|translate }}</span>
      </button>
    }
    @if (kanSlaaSammenCeller()) {
      <button mat-menu-item type="button" (click)="slaaSammenCeller()">
        <mat-icon svgIcon="sf:join-cell"/>
        <span>{{ 'Slå sammen celler'|translate }}</span>
      </button>
    }
    @if (kanSplitteCelle() || kanSlaaSammenCeller()) {
      <mat-divider/>
    }
    <!-- kan ikke putte knappen i en ng-template - da mister vi sub-meny oppførselen -->
    <button mat-menu-item type="button" [matMenuTriggerFor]="margerMeny">
      <mat-icon>margin</mat-icon>
      <span>
        {{ 'Cellemarger'|translate }}
        @if (margIPiksler() != null) {
          {{ margIPiksler() }}px
        } @else {
          -
        }
      </span>
    </button>
    <mat-divider/>
    <ng-container *ngTemplateOutlet="velgBakgrunnsfargeFragment"/>
    <mat-divider/>
    <riktekst-redigering-tabell-rammevalg [skjema]="rammevalgForCelle()" #rammevalgKomponent/>
  </mat-menu>
</span>

@if (erCelleIFoersteRad()) {
  <span class="menytrigger_kolonne" data-ikkePropagerHendelserTilTiptap>
    @if (erCellebreddeSatt()) {
      <span class="cellebredde">
        <mat-icon>west</mat-icon>
        <span>{{ statiskCellebredde() }}px</span>
        <mat-icon>east</mat-icon>
      </span>
    }
    <button mat-icon-button type="button" [matMenuTriggerFor]="kolonnemeny" (menuOpened)="velgKolonne(rammevalgKomponent)" (menuClosed)="kolonnemenyLukket()">
      <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #kolonnemeny="matMenu">
      <button mat-menu-item type="button" (click)="leggTilKolonneFoer()">
        <mat-icon>add_column_left</mat-icon>
        <span>{{ 'Legg til kolonne før'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="leggTilKolonneEtter()">
        <mat-icon>add_column_right</mat-icon>
        <span>{{ 'Legg til kolonne etter'|translate }}</span>
      </button>
      <mat-divider/>
      <button mat-menu-item type="button" (click)="slettKolonne()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'Slett kolonne'|translate }}</span>
      </button>
      @if (erCellebreddeSatt()) {
        <mat-divider/>
        <button mat-menu-item type="button" (click)="nullstillKolonnebredde()">
          <mat-icon>ink_eraser</mat-icon>
          <span>{{ 'Nullstill kolonnebredde'|translate }}</span>
        </button>
      }
      <mat-divider/>
      <!-- kan ikke putte knappen i en ng-template - da mister vi sub-meny oppførselen -->
      <button mat-menu-item type="button" [matMenuTriggerFor]="margerMeny">
        <mat-icon>margin</mat-icon>
        <span>
          {{ 'Cellemarger'|translate }}
          @if (margIPiksler() != null) {
            {{ margIPiksler() }}px
          } @else {
            -
          }
        </span>
      </button>
      <mat-divider/>
      <ng-container *ngTemplateOutlet="velgBakgrunnsfargeFragment"/>
      <mat-divider/>
      <riktekst-redigering-tabell-rammevalg [skjema]="rammevalgForKolonne()" #rammevalgKomponent/>
    </mat-menu>
  </span>
}
@if (erCelleIFoersteKolonne()) {
  <span class="menytrigger_rad" data-ikkePropagerHendelserTilTiptap>
    <button mat-icon-button type="button" [matMenuTriggerFor]="radmeny" (menuOpened)="velgRad(rammevalgKomponent)" (menuClosed)="radmenyLukket()">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #radmeny="matMenu">
      <button mat-menu-item type="button" (click)="leggTilRadFoer()">
        <mat-icon>add_row_above</mat-icon>
        <span>{{ 'Legg til rad før'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="leggTilRadEtter()">
        <mat-icon>add_row_below</mat-icon>
        <span>{{ 'Legg til rad etter'|translate }}</span>
      </button>
      <mat-divider/>
      <button mat-menu-item type="button" (click)="slettRad()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'Slett rad'|translate }}</span>
      </button>
      <mat-divider/>
      <!-- kan ikke putte knappen i en ng-template - da mister vi sub-meny oppførselen -->
      <button mat-menu-item type="button" [matMenuTriggerFor]="margerMeny">
        <mat-icon>margin</mat-icon>
        <span>
          {{ 'Cellemarger'|translate }}
          @if (margIPiksler() != null) {
            {{ margIPiksler() }}px
          } @else {
            -
          }
        </span>
      </button>
      <mat-divider/>
      <ng-container *ngTemplateOutlet="velgBakgrunnsfargeFragment"/>
      <mat-divider/>
      <riktekst-redigering-tabell-rammevalg [skjema]="rammevalgForRad()" #rammevalgKomponent/>
    </mat-menu>
  </span>
}

@if (erCelleIFoersteRad() && erCelleIFoersteKolonne()) {
  <span class="menytrigger_tabell" data-ikkePropagerHendelserTilTiptap>
    <button mat-icon-button type="button" [matMenuTriggerFor]="tabellmeny" (menuOpened)="velgTabell(rammevalgKomponent)" (menuClosed)="tabellmenyLukket()" data-testid="menytrigger_tabell">
      <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #tabellmeny="matMenu">
      <button mat-menu-item type="button" (click)="leggTilRadFoer()">
        <mat-icon>add_row_above</mat-icon>
        <span>{{ 'Legg til rad før'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="leggTilRadEtter()">
        <mat-icon>add_row_below</mat-icon>
        <span>{{ 'Legg til rad etter'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="leggTilKolonneFoer()">
        <mat-icon>add_column_left</mat-icon>
        <span>{{ 'Legg til kolonne før'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="leggTilKolonneEtter()">
        <mat-icon>add_column_right</mat-icon>
        <span>{{ 'Legg til kolonne etter'|translate }}</span>
      </button>
      <mat-divider/>
      <button mat-menu-item type="button" (click)="slettTabell()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'Slett tabell'|translate }}</span>
      </button>
      <mat-divider/>
      <!-- kan ikke putte knappen i en ng-template - da mister vi sub-meny oppførselen -->
      <button mat-menu-item type="button" [matMenuTriggerFor]="margerMeny">
        <mat-icon>margin</mat-icon>
        <span>
          {{ 'Cellemarger'|translate }}
          @if (margIPiksler() != null) {
            {{ margIPiksler() }}px
          } @else {
            -
          }
        </span>
      </button>
      <mat-divider/>
      <ng-container *ngTemplateOutlet="velgBakgrunnsfargeFragment"/>
      <mat-divider/>
      <riktekst-redigering-tabell-rammevalg [skjema]="rammevalgForTabell()" #rammevalgKomponent/>
    </mat-menu>
  </span>
}

<mat-menu class="marg-meny" #margerMeny="matMenu">
  <button mat-menu-item type="button" (click)="fjernMarger()">
    <mat-icon>margin</mat-icon>
    <span>{{ 'Ingen'|translate }}</span>
  </button>
  <button mat-menu-item type="button" (click)="settMarger(5)" [class.valgt]="margIPiksler() == 5">
    <mat-icon>margin</mat-icon>
    <span>5px</span>
  </button>
  <button mat-menu-item type="button" (click)="settMarger(10)" [class.valgt]="margIPiksler() == 10">
    <mat-icon>margin</mat-icon>
    <span>10px</span>
  </button>
  <button mat-menu-item type="button" (click)="settMarger(20)" [class.valgt]="margIPiksler() == 20">
    <mat-icon>margin</mat-icon>
    <span>20px</span>
  </button>
</mat-menu>

<ng-template #velgBakgrunnsfargeFragment>
  <!-- $event.stopPropagation() for å hindre at menyen lukkes når bruker åpner fargevelger -->
  <button mat-menu-item
          type="button"
          (click)="$event.stopPropagation()"
          [formControl]="bakgrunnsfargeKontroll"
          ngx-colors-trigger
          format="hex"
          colorPickerControls="no-alpha"
          acceptLabel="{{'Velg' | translate}}"
          cancelLabel="{{'Avbryt' | translate}}">
    <mat-icon [style.color]="bakgrunnsfargeKontroll.value">colors</mat-icon>
    <span>{{ 'Bakgrunnsfarge'|translate }}</span>
  </button>
  <button mat-menu-item type="button" (click)="fjernBakgrunnsfarge()">
    <mat-icon>ink_eraser</mat-icon>
    <span>{{ 'Fjern bakgrunnsfarge'|translate }}</span>
  </button>
</ng-template>
